import { AxiosResponse } from "axios";
import { IHospitalPayload, IHospitalResponse } from "~/types/hospital";
import { egisApi } from "~/utils/api";

export const fetchHospitalsService = (payload: IHospitalPayload) => {
  return egisApi.post<
    IHospitalResponse,
    AxiosResponse<IHospitalResponse, typeof payload>,
    typeof payload
  >(`/hospitals`, payload);
};
